import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { validFile } from '../../utils/validators';


function AddAttachmentModal({showModal, handleCloseModal, handleAddAttchment}) {


  const [fileTitle, setFileTitle] = useState("")
  const [file, setFile] = useState("")
  const [fileErrorMsg, setFileErrorMsg] = useState('');




  const handleConfirm = async(e) => {
    e.preventDefault()
    let fileObj = {
      title:fileTitle,
      file,
    }
    handleAddAttchment(fileObj)
    handleCloseModal()
    setFileTitle('')
  }

  const handleChooseFile = (e) => {
    let slectedFile = e.target.files[0]
    if(slectedFile) {
        if (validFile(slectedFile.name)) {
            console.log('valid file xxxxxxxx')
            if (fileErrorMsg) {
                setFileErrorMsg('')
            }
            setFile(slectedFile);
        } else {
            setFileErrorMsg('not soported file extention')
        }
    }
  }


  


  
  return (
    <Modal show={showModal} onHide={handleCloseModal} scrollable>
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>إضافة مرفق</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>
            <Form>

               <Form.Group
                className="my-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>عنوان المرفق</Form.Label>
                <Form.Control  
                  placeholder="اكتب عنوان المرفق هنا"
                  className="border-0 bg-light rounded-end px-2"
                  name='attachment-title'
				          onChange={(e)=> setFileTitle(e.target.value)}
                  value={fileTitle}
                 />
              </Form.Group>

              <Form.Group className="my-4">
              <Form.Label>المرفق</Form.Label>
              <Form.Control 
              type="file" 
              onChange={handleChooseFile}/>
            </Form.Group>

              
              
             
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant= "danger-soft" onClick={handleCloseModal}>
            إلغاء
          </Button>

          <Button className='my-0' variant="outline-primary" onClick={handleConfirm}>
            تأكيد
          </Button>
        </Modal.Footer>
    </Modal>
  )
}

export default AddAttachmentModal